module.exports = __webpack_public_path__ + "static/media/scala.af69a8b2.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/cardicons/scala.png
// module id = 1505
// module chunks = 0